const resolution = {width: 900, height: 540};
const packFolder = "mobile_vertical/";
const pathFolder = "mobile_horizontal/";

export const configGame_mobile_horizontal = {
    packFolder: packFolder,
    pathFolder: pathFolder,
    type: "MobileHorizontal",

    Screen: {
        resolution: resolution,
        screen_ratio: resolution.width / resolution.height,
        loadscreen: {
            image: {name: "res/" + pathFolder + "loadscreen.png", rus: true},
            loadbar:{
                position: {x: 262, y: 434},
                image: "res/" + pathFolder + "loadbar.png"
            }
        }
    },

    MainScene: {
        frameUi: {pos: {x: 7, y: 363}},
        logoFix: {pos: {x: 105, y: -370}},
        logoX2: {pos: {x: 41, y: -370}},
        coin: {pos: {x: 321, y: -50}},
        animCoinOrel: {
            from: 7,
            frames: 13,
        },
        animCoinReshka: {
            from: 0,
            frames: 6,
        },
    },

    UiScene: {
        buttonSelectOrel: {pos: {x: 247, y: 379}},
        buttonSelectReshka: {pos: {x: 532, y: 379}},
        buttonGameMode: {pos: {x: 453, y: 722}},
        buttonMore: {pos: {x: 370, y: 601}},
        buttonStop: {pos: {x: 30, y: 601}},
        frameTotalBet: {
            visible: false,
            pos: {x: 14, y: 368},
            labelTotalBet: {
                pos: {x: 163, y: 103},
                font: {
                    name: "font_white_nums_mobile_vertical",
                    tint: 0x00ff66
                }
            },
            labelTotalBetBefore: {
                pos: {x: 0, y: 0},
                font: {
                    name: "arial_regular_16_mobile_vertical",
                }
            },
            labelTotalBetAfter: {
                pos: {x: 0, y: 0},
                font: {
                    name: "arial_regular_20_mobile_vertical",
                }
            },
            chooseOrel: {pos: {x: 37, y: 1}},
            chooseReshka: {pos: {x: 37, y: 8}},
        },
        labelResult: {
            pos: {x: 970, y: -245},
            font: {
                name: "arial_bold_32_mobile_vertical",
            }
        },
        labelCoeff: {
            pos: {x: 425, y: 490},
            font: {
                name: "font_coeff_mobile_vertical",
            }
        },
        imgSelectLightOrel: {pos: {x: 247, y: 379}},
        imgSelectLightReshka: {pos: {x: 532, y: 379}},
        animSelectLightOrel: {pos: {x: 251, y: 383}},
        animSelectLightReshka: {pos: {x: 536, y: 383}},
    },

    UiSceneList: {
        maxListSize: 4,
        startY: 310,
        offY: 30,
        layer: {pos: {x: 475, y: 0}},
        label: {
            pos: {x: 180, y: 0},
            font: {
                name: "font_list_nums_mobile_vertical",
                align: "left",
                anchor: {x: 1.0, y: 0.5}
            }
        },
        labelCurrency: {
            pos: {x: 230, y: 17},
            font: {
                name: "arial_regular_16_currency_mobile_vertical",
                align: "left",
                anchor: {x: 1.0, y: 0.5}
            }
        },
    },

    Settings: {
        background: {pos: {x: 150, y: 63}},
        backgroundTitle: {pos: {x: 146, y: 10}},
        countImg: 6,
        grid: {
            startPos: {x: 118, y: 130},
            stepLength: {x: 172, y: 120},
            scale: {x: 0.17, y: 0.17},
        },
        buttonOk: {pos: {x: 200, y: 325}},
    },

    AccountChangedWindow: {
        background: {pos: {x: 150, y: 63}},
        buttonOk: {pos: {x: 155, y: 310}},
        labelTitle: {
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        }
    },

    Help: {
        background: {pos: {x: 150, y: 63}},
        backgroundTitle: {pos: {x: 186, y: 20}},
        buttonOk: {pos: {x: 175, y: 305}},
        labelTitle: {
            pos: {x: 300, y: 60},
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        },
        labelTitle0: {
            pos: {x: 120, y: 140},
            font: {
                fontFamily: "Arial",
                fontSize: 36,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo: {
            pos: {x: 45, y: 145},
            font: {
                fontFamily: "Arial",
                fontSize: 18,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelTitle1: {
            pos: {x: 120, y: 320},
            font: {
                fontFamily: "Arial",
                fontSize: 36,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo1: {
            pos: {x: 45, y: 325},
            font: {
                fontFamily: "Arial",
                fontSize: 18,
                fill: 0xffffff,
                align: "left"
            }
        },
        translateList: {
            name: {
                rus: 'Игра «Орел или Решка»',
                eng: 'Game «Flip the coin»'
            },
            mode: {
                rus: 'Фиксированная ставка',
                eng: '            Fix bet'
            },
            info: {
                rus: '    Определяетесь с размером ставки и бросаете монетку.\n' +
                '                            Угадали? Поздравляем!\n' +
                '                   Ваша ставка увеличивается в 2 раза!\n',
                eng: '    Choose either head or tail and select the value of your bet.\n' +
                '                   Then flip the coin. Did you guess right?\n' +
                '                                If yes, your bet is doubled!\n'
            },
            mode1: {
                rus: 'Удвоение ставки',
                eng: '            Doubling bet'
            },
            info1: {
                rus: '     Вы выбираете Орла или Решку и делаете ставку 50 RUB.\n' +
                '                             Угадали?\n' +
                '          Можете забрать выигрыш 100 RUB или бросить еще раз...\n',
                eng: '    Choose .\n'
            },
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_horizontal/game.es6
// module id = 41
// module chunks = 0